import React, { useMemo } from 'react';
import { designSystem } from '@yola/ws-ui';
import { i18next } from '@yola/ws-sdk';
import TriggerWithUpgradePopover from 'src/js/modules/extensions/registry/ws-composite-group/components/trigger-with-upgrade-popover';
import TriggerLabel from 'src/js/modules/common/components/trigger-label';
import common from 'src/js/modules/extensions/registry/ws-composite-group/constants/common';
import getCreateLayoutTriggerWidth from 'src/js/modules/extensions/registry/ws-composite-group/helpers/get-create-layout-trigger-width';

const { Box, Icon } = designSystem;
const { CREATE_LAYOUT_TRIGGER_ID } = common;

const CreateLayoutTrigger = () => {
  const triggerWidth = useMemo(() => getCreateLayoutTriggerWidth(), []);

  return (
    <TriggerWithUpgradePopover id={CREATE_LAYOUT_TRIGGER_ID} triggerWidth={triggerWidth}>
      <Box marginLeft="spacing-3-xs" />
      <Icon glyph="isotope-layout" size={18} />
      <TriggerLabel className="ws-trigger-label__custom-padding">
        {i18next.t('Create layout')}
      </TriggerLabel>
    </TriggerWithUpgradePopover>
  );
};

CreateLayoutTrigger.displayName = 'CreateLayoutTrigger';

export default CreateLayoutTrigger;
